
<div class="footer-text">
    <span>&copy; 2024 MARUTI SUZUKI INDIA LIMITED | Powered By - AdGlobal360</span>
</div>